import * as z from "zod";

/**
 * Type-check a stored artifact against what its host now says its Input and
 * Output are, without storing or running anything. A host whose types can
 * change after the code was saved (an automation Function step's input query
 * and Output) uses this to tell the author the code no longer fits.
 */
export const checkExtensionArtifact = {
  name: "checkExtensionArtifact" as const,
  input: z.object({
    artifactId: z.string(),
    /** What the host knows about this artifact's Input and Output (see Contract.specialize). */
    typeShapes: z
      .object({ input: z.unknown().optional(), output: z.unknown().optional() })
      .optional(),
  }),
  output: z.object({
    /** Type errors, one per line of the checker's output; empty when the code fits. */
    problems: z.array(z.string()),
  }),
};
